"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VehiclesService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token", "id"],
  _excluded3 = ["token", "id"],
  _excluded4 = ["token", "id"],
  _excluded5 = ["token", "id"],
  _excluded6 = ["token"],
  _excluded7 = ["token"],
  _excluded8 = ["token"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VehiclesService = exports.VehiclesService = /*#__PURE__*/(0, _createClass2["default"])(function VehiclesService() {
  (0, _classCallCheck2["default"])(this, VehiclesService);
});
(0, _defineProperty2["default"])(VehiclesService, "list", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('/vehicle', {
    params: params
  });
});
(0, _defineProperty2["default"])(VehiclesService, "delete", function (_ref2) {
  var token = _ref2.token,
    id = _ref2.id,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token)["delete"]("/vehicle/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(VehiclesService, "deleteType", function (_ref3) {
  var token = _ref3.token,
    id = _ref3.id,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token)["delete"]("/vehicle/type/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(VehiclesService, "edit", function (_ref4) {
  var token = _ref4.token,
    id = _ref4.id,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).patch("/vehicle/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(VehiclesService, "editType", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).patch("/vehicle/type/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(VehiclesService, "listType", function (_ref6) {
  var token = _ref6.token,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token).get('/vehicle/type', {
    params: params
  });
});
(0, _defineProperty2["default"])(VehiclesService, "create", function (_ref7) {
  var token = _ref7.token,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token).post('/vehicle', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(VehiclesService, "createType", function (_ref8) {
  var token = _ref8.token,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return _Api["default"].withAuth(token).post('/vehicle/type', _objectSpread({}, params));
});